import { render, staticRenderFns } from "./ProductsInfiniteScroll.vue?vue&type=template&id=f2fd7a52&scoped=true&"
import script from "./ProductsInfiniteScroll.vue?vue&type=script&lang=js&"
export * from "./ProductsInfiniteScroll.vue?vue&type=script&lang=js&"
import style0 from "./ProductsInfiniteScroll.vue?vue&type=style&index=0&id=f2fd7a52&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fd7a52",
  null
  
)

export default component.exports